// extracted by mini-css-extract-plugin
export default {"approveSectionButton":"ApproveButton_approveSectionButton__F7BMB"};